type ScannedEmailCopy = { id: string; userId?: string };

export function pickOpenEmailMessageId(
  copies: ScannedEmailCopy[],
  userId?: string
): string | undefined {
  const ownCopy = copies.find((copy) => copy.userId === userId);
  return (ownCopy ?? copies[0])?.id;
}
